import * as React from 'react';
export const walletSvg = React.forwardRef(function walletSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D8DEE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 10.855c0-1 .681-1.845 1.632-2.1l.023-.005L19.19 6.266c.187-.047.375-.069.56-.068 1.159.007 2.188.915 2.188 2.175v3.252h.937A3.125 3.125 0 0 1 26 14.75v8.125C26 24.6 24.6 26 22.875 26H9.125A3.125 3.125 0 0 1 6 22.875v-12.02Zm13.64-2.77c.25-.064.422.113.422.288v3.252H9.126c-.444 0-.867.093-1.25.26v-1.03c0-.114.074-.236.226-.284l11.52-2.48.02-.005ZM7.876 14.75v8.125c0 .69.56 1.25 1.25 1.25h13.75c.69 0 1.25-.56 1.25-1.25V14.75c0-.69-.56-1.25-1.25-1.25H9.125c-.69 0-1.25.56-1.25 1.25Z',
      fill: '#474E5A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm19.621 8.09-11.52 2.482c-.153.047-.226.169-.226.283v1.03c.383-.167.806-.26 1.25-.26h10.938V8.373c0-.175-.173-.352-.422-.287m0 0-.02.005ZM7.655 8.75 19.19 6.266c.187-.047.375-.069.56-.068 1.159.007 2.188.915 2.188 2.175v3.252h.937A3.125 3.125 0 0 1 26 14.75v8.125C26 24.6 24.6 26 22.875 26H9.125A3.125 3.125 0 0 1 6 22.875v-12.02c0-1 .681-1.845 1.632-2.1l.023-.005Zm.22 14.125V14.75c0-.69.56-1.25 1.25-1.25h13.75c.69 0 1.25.56 1.25 1.25v8.125c0 .69-.56 1.25-1.25 1.25H9.125c-.69 0-1.25-.56-1.25-1.25Zm14.375-4.063c0 .86-.703 1.563-1.563 1.563a1.557 1.557 0 0 1-1.562-1.563c0-.859.703-1.562 1.563-1.562.859 0 1.562.703 1.562 1.562Z',
      fill: '#474E5A',
    }),
  );
});
walletSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wallet = {
  category: 'brand',
  colorable: false,
  name: 'wallet',
  svg: walletSvg,
};
